import React from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { H2, Copy } from '../../style';

const Container = styled.div`
  margin-bottom: ${(props) => props.theme.whitespace.large};
  text-align: ${(props) => props.justify};
`;

const Primary = styled(H2)`
  text-align: inherit;
`;

const Secondary = styled(Copy)`
  margin: 0;
  padding: 0;
  text-align: inherit;
`;

const BlockHeader = ({ primary, secondary, ...props }) => (
  <Container {...props}>
    {primary && <Primary>{parse(primary)}</Primary>}
    {secondary && <Secondary>{parse(secondary)}</Secondary>}
  </Container>
);

BlockHeader.propTypes = {
  primary: PropTypes.string,
  secondary: PropTypes.string,
  justify: PropTypes.string
};

BlockHeader.defaultProps = {
  primary: null,
  secondary: null,
  justify: 'left'
};

export default BlockHeader;
